import { CloudHostSVG } from '@sbercloud/uikit-product-icons';

export {
  CloudHostSVG as CloudWebsiteHost,
  CloudHostSVG as CloudWebsiteHostSVG,
};
